<template>
  <div class="bg-litergray p-5">
    <section
      v-if="getting"
      class="flex justify-center items-center h-[70vh] w-full"
    >
      <spinner class="w-20 h-20" color="oneGreen"></spinner>
    </section>

    <template v-else>
      <section>
        <DataField v-for="(val, i) in fields" :key="i" :field="val" />
      </section>

      <ActionButton
        :doc="doc"
        :update="true"
        @next="next()"
        @approved="updateData('approved')"
        @rejected="openReject = true"
        @requested="openUpdate = true"
        @authorized="updateData('authorized')"
      />
    </template>

    <template>
      <RejectRecord
        v-model="rejectReason"
        :open="openReject"
        @close="openReject = false"
        @rejected="updateData('rejected')"
      />

      <UpdateRecord
        :open="openUpdate"
        @close="openUpdate = false"
        @updated="updateRequest"
        :records="Object.values(fields)"
      />
    </template>
  </div>
</template>

<script>
import DataField from "@/components/admin/element/DataField.vue";
import RejectRecord from "@/components/admin/records/RejectRecord.vue";
import ActionButton from "@/components/admin/records/ActionButton.vue";
import UpdateRecord from "@/components/admin/records/UpdateRecord.vue";

export default {
  name: "AdminNextOfKin",
  components: {
    DataField,
    RejectRecord,
    ActionButton,
    UpdateRecord,
  },
  data() {
    return {
      userId: null,
      getting: false,
      doc: null,
      rejectReason: null,
      openReject: false,
      openUpdate: false,
      staffType: null,
      fields: {
        lastName: {
          key: "lastName",
          value: "null",
          label: "Last Name",
        },
        firstName: {
          key: "firstName",
          value: null,
          label: "First Name",
        },
        middleName: {
          key: "middleName",
          value: null,
          label: "Middle Name",
        },
        relationship: {
          key: "relationship",
          value: null,
          label: "Relationship",
        },
        kinGender: {
          key: "kinGender",
          value: null,
          label: "Gender",
        },
        kinPhone: {
          key: "kinPhone",
          value: null,
          label: "KIN Phone Number",
        },
        kinAddress: {
          key: "kinAddress",
          value: null,
          label: "KIN Address",
        },
      },
    };
  },
  async created() {
    this.$store.commit("staff/updateBStep", 2);
    this.userId = this.$route.params.id;
    await this.getData();
  },
  methods: {
    next() {
      if (this.staffType.includes("pension"))
        this.$router.push({ name: "Admin Employment Data" });
      else this.$router.push({ name: "Admin Education" });
    },
    async getData() {
      try {
        this.getting = true;

        const res = await this.$http.get(`process/employee/${this.userId}/kin`);

        if (!res) {
          this.getting = false;
          return;
        }

        const { data } = res.data;

        this.doc = data;
        this.staffType = data.staffType;
        for (const fld in this.fields) {
          if (Object.hasOwnProperty.call(this.fields, fld)) {
            this.fields[fld].value = data[fld];
          }
        }

        this.getting = false;
      } catch (error) {
        this.getting = false;
        console.log({ error });
      }
    },
    async updateData(acn) {
      try {
        const wrd =
          acn === "approved"
            ? "Approve"
            : acn === "authorized"
            ? "Authorize"
            : "Reject";
        const rep = await this.$swal({
          icon: "question",
          text: `Are you sure you want to ${wrd} this record?`,
          showDenyButton: true,
          confirmButtonText: "YES",
          denyButtonText: "No",
        });

        if (!rep.isConfirmed) {
          return;
        }

        this.$store.commit("general/toggleLoad");
        const payload = { flag: acn };
        if (this.rejectReason) payload.reason = this.rejectReason;

        const res = await this.$http.patch(
          `process/employee/${this.userId}/kin/${this.doc._id}`,
          payload
        );

        this.$store.commit("general/toggleLoad");
        if (!res) {
          return;
        }

        // update docs
        this.doc = res.data.data;
        if (acn !== "rejected") this.next();

        this.$swal({
          icon: "success",
          text: `Record ${acn} successfully`,
        });
      } catch (error) {
        console.log({ error });
      }
    },
    async updateRequest(dtt) {
      try {
        console.log(dtt);
        const rep = await this.$swal({
          icon: "question",
          text: `Are you sure you want to update this record?`,
          showDenyButton: true,
          confirmButtonText: "Proceed",
          denyButtonText: "No",
        });

        if (!rep.isConfirmed) {
          return;
        }

        this.$store.commit("general/toggleLoad");

        const res = await this.$http.patch(
          `process/employee/${this.userId}/update-kin`,
          {
            label: dtt.record.key,
            oldValue: dtt.oldValue,
            newValue: dtt.newValue,
            updateReason: dtt.updateReason,
          }
        );

        this.$store.commit("general/toggleLoad");
        if (!res) {
          return;
        }
        this.openUpdate = false;

        // update docs
        console.log(res.data);
        // this.doc = res.data.data;
        this.getData();

        this.$swal({
          icon: "success",
          text: `Record update successfully`,
        });
      } catch (error) {
        this.$store.commit("general/toggleLoad");
        console.log({ error });
      }
    },
  },
};
</script>
